<template>
    <v-row class="main-row-fill-height">
        <!-- <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;">
                    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
                        <v-toolbar-title>Montagematerial</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pt-0">
                        <v-list-item-group v-model="active" color="grey darken-4">
                            <v-list-item :style="active === index ? 'pointer-events: none' : ''"
                                v-for="(item, index) in getMountingMaterialItems" :key="index">
                                <v-list-item-content>
                                    <div class="subtitle-1 d-flex align-center justify-space-between">
                                        {{ item.displayText }}
                                        <v-icon v-if="item.completed()" color="success" class="ml-4">mdi-check-circle
                                        </v-icon>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-col> -->
        <v-col cols="9" class="pa-0 pos-rel pad-b">
            <div class="top-bar pl-14 pr-10 py-8" ref="topBar">
                <div class="content">
                    <div class="text-section">
                        <h2 class="mb-2 menu-title">{{ $t('montagematerial') }}</h2>
                        <p class="ma-0 menu-description">{{$t('montagematerialDescription')}}</p>
                    </div>
                    <!-- Eshte komentuar per shkak se nuk eshte dokuemnti i duhur per kete step -->
                    <!-- <a href="javascript:void(0)" @click="toggleResources = !toggleResources" class="resources-holder" v-if="showResources">
                        <div class="resources" :class="{ 'active': toggleResources }">
                            <div class="resources-placeholders">
                                <p>{{ $t('resourcesLabel') }}</p>
                                <p class="font-weight-bold"><span v-if="(typeof bodenniveauunterschiedDocument !== 'undefined')">1 {{$t('documentLabel')}}</span><span v-else>0 {{$t('documentsLabel')}}</span></p>
                            </div>
                            <div class="pl-5 dropdown-icon">
                                <v-icon class="icon-class">mdi-menu-down</v-icon>
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div class="resources-dropdown" v-if="toggleResources">
                                <div class="resources-placeholders">
                                    <p>{{ $t('resourcesLabel') }}</p>
                                    <p class="font-weight-bold"><span v-if="(typeof bodenniveauunterschiedDocument !== 'undefined')">1 {{$t('documentLabel')}}</span><span v-else>0 {{$t('documentsLabel')}}</span></p>
                                </div>
                                <div class="resources-content">
                                    <div v-if="(typeof bodenniveauunterschiedDocument !== 'undefined')" class="d-flex pa-3 mb-4 document-container" >
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank" :href="bodenniveauunterschiedDocument.resourceLocation" download>Bodenniveauunterschied Bild</a>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </a> -->
                </div>
            </div>
            <v-divider></v-divider>
            <v-card data-simplebar flat :style="{'height': `calc(100% - ${bodyCalcHeight}px)`, 'max-height' : '100%'}" class="pa-8 pl-12 pt-6">
                <simplebar style="overflow-x: hidden;" class="px-2">
                <template v-if="active == 0">
                    <v-form ref="mountingMaterialForm" v-model="valid" lazy-validation>
                        <h3 class="font-weight-regular mb-4 submenu-title">{{$t('montagematerialTitle')}}</h3>
                        <v-row>
                            <v-col md="6" sm="12">
                                <div class="subtitle-2 mb-2">{{$t('artDesMaterials')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }" :items="filteredMaterialArts"
                                    item-text="description" :value="mainMaterialArt.value"
                                    @change="setMainMaterialArtValue(getCharacteristicAndValues('CUST_MM_ART_MATERIAL'), $event);filterDependencies();">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="6" sm="12" class="py-0">
                                <div class="subtitle-2 mb-2 ml-3">{{$t('selectMaterial')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="grosseSourceListCharacteristic.values" item-text="description"
                                    :value="mountingMaterialItem.grosse.value"
                                    @change="addMaterialItemCharacterisitc('grosse', grosseSourceListCharacteristic, $event); ">
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('beschichtungsseite')}}
                                    <!-- [CUST_MM_BESCHICHTUNGSSEITE] -->
                                </div>
                                <v-select dense outlined hide-details return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE').values"
                                    :value="mountingMaterialItem.beschichtungsseite.value"
                                    @change="addMaterialItemCharacterisitc('beschichtungsseite', getCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE'), $event);filterDependencies()">
                                    <template slot="selection" slot-scope="data">
                                        <!-- HTML that describe how select should render selected items -->
                                        {{ data.item.description.toLowerCase() }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <!-- HTML that describe how select should render items when the select is open -->
                                        {{ data.item.description.toLowerCase() }}
                                    </template>
                                </v-select>
                            </v-col>

                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('farbe')}}
                                    <!-- [CUST_MM_FARBE] -->
                                </div>
                                <v-select dense outlined hide-details return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('CUST_MM_FARBE').values" item-text="description"
                                    :value="mountingMaterialItem.farbe.value"
                                    @change="addMaterialItemCharacterisitc('farbe', getCharacteristicAndValues('CUST_MM_FARBE'), $event)">
                                </v-select>
                            </v-col>

                            <v-col cols="6" :class="{'mb-n6' : !isSpecialHohe(mainMaterialArt.value, mountingMaterialItem.grosse.value)}">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('hoheStarke')}}</div>
                                <v-text-field class="unit-text-field" 
                                    v-model="itemHoehe" 
                                    :rules="[rules.maxValue(parseFloatFromGermanFloat(hoeheValue) ,parseInt(this.getHeightProperty()), $t('maximumAllowedValue')),
                                    rules.minValue(parseFloatFromGermanFloat(hoeheValue), $t('requiredValueLabel'))]"
                                    :disabled="isSpecialHohe(mainMaterialArt.value, mountingMaterialItem.grosse.value)" 
                                    dense outlined :hide-details="isSpecialHohe(mainMaterialArt.value, mountingMaterialItem.grosse.value)"
                                    suffix="mm">
                                </v-text-field>
                            </v-col>

                            <v-col cols="6" :class="{'mb-n6' : !isSpecialDesign(mainMaterialArt.value, mountingMaterialItem.grosse.value)}">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('breite')}}</div>
                                <v-text-field class="unit-text-field" 
                                    v-model="itemBreite" 
                                    :rules="[rules.maxValue(parseFloatFromGermanFloat(breiteValue) ,parseInt(this.getWidthProperty()), $t('maximumAllowedValue')),
                                    rules.minValue(parseFloatFromGermanFloat(breiteValue), $t('requiredValueLabel'))]"
                                    :disabled="isSpecialDesign(mainMaterialArt.value, mountingMaterialItem.grosse.value)" 
                                    dense outlined :hide-details="isSpecialDesign(mainMaterialArt.value, mountingMaterialItem.grosse.value)"
                                    suffix="mm">
                                </v-text-field>
                            </v-col>

                            <v-col cols="6">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('lange')}}</div>
                                <v-text-field
                                    class="unit-text-field"
                                    v-model="itemLaenge"
                                    :rules="[rules.minValue(parseFloatFromGermanFloat(laengeValue), $t('requiredValueLabel'))]"
                                    dense outlined suffix="mm">
                                </v-text-field>
                            </v-col>

                            <v-col cols="6">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('anzahl')}}</div>
                                <v-text-field
                                    class="unit-text-field"
                                    v-model="itemAnzahl"
                                    :rules="[rules.minValue(parseFloatFromGermanFloat(anzahlValue), $t('requiredValueLabel'))]"
                                    @focus="selectText()"
                                    id="itemAnzahl"
                                    dense outlined suffix="Stk.">
                                </v-text-field>
                            </v-col>

                        </v-row>
                        <div class="buttons d-flex mx-2 justify-start mb-2">
                            <v-btn min-width="100px" color="primary" @click="addMaterialItem()" class="col-3 mr-4 mt-3">{{$t('addItem')}}</v-btn>
    <!--                        <v-btn min-width="100px" color="red" @click="removeItem(1)" class="col-6 white&#45;&#45;text">{{$t('clear')}}</v-btn>-->
                        </div>
                    </v-form>

                    <v-data-table dense :headers="tableHeders" :hide-default-footer="true" :items="getMountingMaterialsList" disable-pagination>
                        <template #item.vorhandeneEintrage="{ item }">
                            <div class="text">{{item.materialArt.value.description}}</div>
                        </template>

                        <template #item.grobe="{ item }">
                            <div class="text">{{item.grosse.value.description}}</div>
                        </template>

                         <template #item.beschichtungsseite="{ item }">
                            <div class="text">{{item.beschichtungsseite.value.description}}</div>
                        </template>

                        <template #item.farbe="{ item }">
                            <div class="text">{{item.farbe.value.description}}</div>
                        </template>

                        <template #item.hohe="{ item }">
                            <div class="text">{{item.hoehe.value.value}}</div>
                        </template>

                        <template #item.breite="{ item }">
                            <div class="text">{{item.breite.value.value}}</div>
                        </template>

                        <template #item.lange="{ item }">
                            <div class="text">{{item.laenge.value.value}}</div>
                        </template>

                        <template #item.anzahl="{ item }">
                            <div class="text">{{item.anzahl.value.value}}</div>
                        </template>

                        <template #item.actions="{ item }">
                            <v-btn
                                    class="mx-2"
                                    fab
                                    dark
                                    x-small
                                    color="red"
                                    @click="clearMountingMaterialList(item)"
                            >
                                <v-icon dark>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:no-data>
                            {{$t('noDataAvailable')}}
                        </template>
                        <template v-slot:no-results>
                            {{$t('noDataAvailable')}}
                        </template>
                    </v-data-table> 
                </template>
                </simplebar>
            </v-card>
                <div class="bottom-bar pb-6 text-center">
                    <v-divider class="py-4"></v-divider>
                    <v-btn :disabled="nextSaveBtnDisabled" depressed color="green" dark @click="nextStep();">{{$t('nextStepLabel')}}</v-btn>
                </div>
        </v-col>
        <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;" permanent>
                    <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                        <ModelsFound />
                        <div class="pr-1">
                            <v-expansion-panels flat accordion>
                                <RModelSelection />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFunctions />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFrame />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RMeasures />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RDoorLeafSurface />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RExteriorAccessory />
                            </v-expansion-panels>
<!--                            <v-expansion-panels flat accordion>-->
<!--                                <RMountingMaterial></RMountingMaterial>-->
<!--                            </v-expansion-panels>-->

                        </div>
                        <div class="d-flex flex-column pa-4 right-buttons-holder">
                            <v-row class="px-2">
                                <v-col cols="6" class="px-2" v-if="newConfiguration">
                                    <v-btn outlined color="primary" width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">
                                        {{ $t('cancelConfiguration') }}
                                    </v-btn>
                                </v-col>
                                <v-col class="px-2" :class="!newConfiguration? 'col-12' : 'col-6'">
                                    <SaveCurrentConfiguration :disabled-save-btn="nextSaveBtnDisabled"/>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../configurator/DoorConfiguration';
    import {
        MainNavigationFilter
    } from '../../configurator/MainNavigation';

    import {
        Characteristic,
        ValueDefinition,
        MapCharacteristicAndValue,
        MountingMaterialItemToSapMapper,
    } from '../../configurator/types';


    import ModelsFound from './components/ModelsFound.vue';
    import RModelSelection from './components/RModelSelection.vue';
    import RFunctions from './components/RFunctions.vue';
    import RFrame from './components/RFrame.vue';
    import RMeasures from './components/RMeasures.vue';
    import RDoorLeafSurface from './components/RDoorLeafSurface.vue';
    import RExteriorAccessory from './components/RExteriorAccessory.vue';
    import RMountingMaterial from './components/RMountingMaterial.vue';

    import mountingMaterialService from '../../services/Configurator/MountingMaterialService';

    import SaveCurrentConfiguration from './components/SaveCurrentConfiguration';
    import simplebar from 'simplebar-vue';
    import 'simplebar/dist/simplebar.min.css';
    import {filterMountingMaterialColor} from "../../configurator/Helpers/StoreHelpers";
    import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../services/ParserService';

    export default Vue.extend({
        name: 'MountingMaterial',
        components: {
            simplebar,
            RModelSelection,
            RFunctions,
            RFrame,
            RMeasures,
            RDoorLeafSurface,
            RExteriorAccessory,
            RMountingMaterial,
            ModelsFound,
            SaveCurrentConfiguration,
        },
        data() {
            return {
                parseFloatFromGermanFloat: parseFloatFromGermanFloat,
                valid: true,
                showResources: true,
                toggleResources: false,
                bodyCalcHeight: 0,
                tableHeders: 
                    [{
                            text: 'Vorhandene Einträge',
                            value: 'vorhandeneEintrage'
                        },
                        {
                            text: 'Größe',
                            value: 'grobe'
                        },
                        {
                            text: 'Beschichtungsseite',
                            value: 'beschichtungsseite'
                        },
                        {
                            text: 'Farbe',
                            value : 'farbe'
                            
                        },
                        {
                            text: 'Höhe [mm]',
                            value : 'hohe'
                           
                        },
                        {
                            text: 'Breite [mm]',
                            value: 'breite'
                        },
                        {
                            text: 'Länge [mm]',
                            value : 'lange'
                        },
                        {
                            text: 'Anzahl [Stk.]',
                            value : 'anzahl'
                        },
                        {
                            text: '',
                            sortable: false,
                            value: 'actions',
                            align: 'end'
                        },
                    ],
                showModal: false,
                showSettingsContent: 1,
                active: 0,
                windowMainNavId: 7,
                settignsItems: [],
                rules:{
                    maxValue(value, max, message){
                        if(max !== 0)
                            return (value || "") <= max || `${message} ${max}`;
                        return true;                        
                    },
                    minValue(value, message){
                        return (value || "") > 0 || message;
                    }
                },
                nextSaveBtnDisabled: false,
                constCharacteristics: {
                    WINKEL_OPTION: {
                        NAME: 'WINKEL',
                        ANZ_FIELD: 'KTU_MM_WINKEL_ANZ',
                        BREITE_FIELD: 'KTU_MM_WINKEL_BREITE',
                        LAENGE_FIELD: 'KTU_MM_WINKEL_LAENGE'
                    },
                    ABDECKLEISTE_OPTION: {
                        NAME: 'ABDECKLEISTE',
                        ANZ_FIELD: 'KTU_MM_ABDECKLEISTE_ANZ',
                        BREITE_FIELD: 'KTU_MM_ABDECKLEISTE_BREITE',
                        LAENGE_FIELD: 'KTU_MM_ABDECKLEISTE_LAENGE',
                        HOEHE_FIELD: 'KTU_MM_ABDECKLEISTE_HOEHE'
                    },
                    MDF_OPTION: {
                        NAME: 'AUFDOPPELUNG',
                        ANZ_FIELD: 'KTU_MM_MDF_ANZ',
                        BREITE_FIELD: 'KTU_MM_MDF_BREITE',
                        LAENGE_FIELD: 'KTU_MM_MDF_LAENGE',
                        HOEHE_FIELD: 'KTU_MM_MDF_HOEHE'
                    },
                    FIELDS: {
                        ANZ_FIELD: 'ANZ_FIELD',
                        BREITE_FIELD: 'BREITE_FIELD',
                        LAENGE_FIELD: 'LAENGE_FIELD',
                        HOEHE_FIELD: 'HOEHE_FIELD'
                    }
                },

                uiCharacteristics: [{
                        materialArtValue: 'WINKEL',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_WINKEL'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_WINKEL_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_WINKEL_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'CUST_MM_WINKEL_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_WINKEL_LAENGE'
                            },
                            {
                                item: 'surface',
                                code: 'KTU_MM_WINKEL_O'
                            },
                            {
                                item: 'art',
                                code: 'KTU_MM_WINKEL_O_ART'
                            },
                            {
                                item: 'specialSurface',
                                code: 'KTU_MM_WINKEL_O_SO'
                            },
                        ]
                    },
                    {
                        materialArtValue: 'ABDECKLEISTE',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_ABDECKLEISTE'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_ABDECKLEISTE_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_ABDECKLEISTE_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'KTU_MM_ABDECKLEISTE_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_ABDECKLEISTE_LAENGE'
                            },
                            {
                                item: 'surface',
                                code: 'KTU_MM_ABDECKLEISTE_O'
                            },
                            {
                                item: 'art',
                                code: 'KTU_MM_ABDECKLEISTE_O_ART'
                            },
                            {
                                item: 'specialSurface',
                                code: 'KTU_MM_ABDECKLEISTE_O_SO'
                            },
                        ]
                    },
                    {
                        materialArtValue: 'BLINDSTOCK',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_BLINDSTOCK_MM'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_BLINDSTOCK_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_BLINDSTOCK_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'KTU_MM_BLINDSTOCK_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_BLINDSTOCK_LAENGE'
                            },
                        ]
                    },
                    {
                        materialArtValue: 'AUFDOPPELUNG',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_MDF'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_MDF_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_MDF_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'KTU_MM_MDF_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_MDF_LAENGE'
                            },
                        ]
                    }
                ],

                mountingMaterialItem: {
                    id: '',
                    materialArt: {},
                    grosse: {},
                    beschichtungsseite: {},
                    farbe: {},
                    hoehe: {},
                    breite: {},
                    laenge: {},
                    anzahl: {},
                },

                mountingMaterialCharacteristicsForSap: [
                    "KTU_MM_ABDECKLEISTE",
                    "KTU_MM_ABDECKLEISTE_ANZ",
                    "KTU_MM_ABDECKLEISTE_BREITE",
                    "KTU_MM_ABDECKLEISTE_HOEHE",
                    "KTU_MM_ABDECKLEISTE_LAENGE",
                    "KTU_MM_ABDECKLEISTE_O", 
                    "KTU_MM_ABDECKLEISTE_O_ART",
                    "KTU_MM_ABDECKLEISTE_O_SO",
                    "KTU_MM_BLINDSTOCK_MM",
                    "KTU_MM_BLINDSTOCK_ANZ",
                    "KTU_MM_BLINDSTOCK_BREITE",
                    "KTU_MM_BLINDSTOCK_HOEHE",
                    "KTU_MM_BLINDSTOCK_LAENGE",
                    "KTU_MM_MDF",
                    "KTU_MM_MDF_ANZ",
                    "KTU_MM_MDF_BREITE",
                    "KTU_MM_MDF_HOEHE",
                    "KTU_MM_MDF_LAENGE",
                    "KTU_MM_WINKEL",
                    "KTU_MM_WINKEL_ANZ",
                    "KTU_MM_WINKEL_BREITE",
                    "KTU_MM_WINKEL_LAENGE",
                    "KTU_MM_WINKEL_O",
                    "KTU_MM_WINKEL_O_ART",
                    "KTU_MM_WINKEL_O_SO",
                ],

                mountingMaterialCharacteristicsForSapAbdeckleiste: [
                    "KTU_MM_ABDECKLEISTE",
                    "KTU_MM_ABDECKLEISTE_ANZ",
                    "KTU_MM_ABDECKLEISTE_BREITE",
                    "KTU_MM_ABDECKLEISTE_HOEHE",
                    "KTU_MM_ABDECKLEISTE_LAENGE",
                    "KTU_MM_ABDECKLEISTE_O",
                    "KTU_MM_ABDECKLEISTE_O_ART",
                    "KTU_MM_ABDECKLEISTE_O_SO",
                ],

                mountingMaterialCharacteristicsForSapMdf: [
                    "KTU_MM_MDF",
                    "KTU_MM_MDF_ANZ",
                    "KTU_MM_MDF_BREITE",
                    "KTU_MM_MDF_HOEHE",
                    "KTU_MM_MDF_LAENGE",
                ],

                mountingMaterialCharacteristicsForSapWinkel: [
                    "KTU_MM_WINKEL",
                    "KTU_MM_WINKEL_ANZ",
                    "KTU_MM_WINKEL_BREITE",
                    "KTU_MM_WINKEL_LAENGE",
                    "KTU_MM_WINKEL_O",
                    "KTU_MM_WINKEL_O_ART",
                    "KTU_MM_WINKEL_O_SO",
                ],

                mainMaterialArt: {},

                grosseSourceListCharacteristic: {},

                childCharacteristicsLocal: [],
                bodenniveauunterschiedDocument: {},
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration', 'getMainNav',
                'getRegisteredCharacteristicsValue', 'getMountingMaterialItems'
            ]),
            ...mapGetters('mountingMaterialModule', ['getStepCharacteristics', 'getCharacteristicAndValues',
                'getMountingMaterialsList', 'getChildCharacteristics', 'getMountingMaterialItemsForSap'
            ]),
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            },

            // childCharacteristics() {
            //     const _this: any = this;
            //     if (this.childCharacteristicsLocal.length == 0) {
            //         this.childCharacteristicsLocal = _this.getChildCharacteristics;
            //     } 
            // },
            filteredMaterialArts() {
                const _this = this;
                return _this.getCharacteristicAndValues('CUST_MM_ART_MATERIAL').values.filter((item) => item
                    .value !== 'BLINDSTOCK')
            },

            grosseSource() {
                const _this = this;
                this.grosseSourceListCharacteristic = _this.getCharacteristicAndValues(this.mainElementCode);

                return this.grosseSourceListCharacteristic;
            },
            mainElementCode() {
                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_WINKEL';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'material')[0].code;
                return code;
            },
            numberOfItemsCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_WINKEL_ANZ';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'quantity')[0].code;
                return code;
            },
            elementWidthCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_WINKEL_BREITE';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'width')[0].code;
                return code;
            },
            elementHeightCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'CUST_MM_WINKEL_HOEHE';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'height')[0].code;
                return code;
            },
            elementLengthCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_WINKEL_LAENGE';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'length')[0].code;
                return code;
            },
            // elementColorCode() {
            //     const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this.mainMaterialArt.value.value)[0];
            //     const code = uiCharacteristic.characteristics.filter(x => x.item === 'surface')[0].code;
            //     return code;
            // },


            itemHoehe: {
                get: function () {
                    const _this = this;
                    // const propertyValue = this.getHeightProperty();
                    // const isDisabled = this.isSpecialHohe(this.mainMaterialArt.value, this.mountingMaterialItem.grosse.value);

                    // if (Object.keys(_this.mountingMaterialItem.hoehe).length > 0) {
                    //     _this.mountingMaterialItem.hoehe.value.value = propertyValue;
                    //     return parseToGermanFloat(propertyValue);
                    // }

                    // return 0;
                    if (Object.keys(this.mountingMaterialItem.hoehe).length > 0)
                        return parseToGermanFloat(_this.mountingMaterialItem.hoehe.value.value);
                    return 0;
                },
                set: function (newValue) {
                    if (Object.keys(this.mountingMaterialItem.hoehe).length > 0)
                       this.mountingMaterialItem.hoehe.value.value = parseFloatFromGermanFloat(newValue);      

                }
            },
            itemBreite: {
                get: function () {
                    const _this = this;
                    // const propertyValue = this.getWidthProperty();
                    // const isDisabled = this.isSpecialDesign(this.mainMaterialArt.value, this.mountingMaterialItem.grosse.value);

                    // if (Object.keys(this.mountingMaterialItem.breite).length > 0) {
                    //     if(propertyValue !== '0') {
                    //         this.mountingMaterialItem.breite.value.value = propertyValue;
                    //         return parseToGermanFloat(propertyValue);
                    //     }else {
                    //         return parseToGermanFloat(this.mountingMaterialItem.breite.value.value);
                    //     }

                    // }

                    if (Object.keys(this.mountingMaterialItem.breite).length > 0)
                        return parseToGermanFloat(_this.mountingMaterialItem.breite.value.value);
                    return 0;
                },
                set: function (newValue) {
                    if (Object.keys(this.mountingMaterialItem.breite).length > 0)
                        this.mountingMaterialItem.breite.value.value = parseFloatFromGermanFloat(newValue);
                }
            },
            itemLaenge: {
                get: function () {
                    const _this = this;
                    return Object.keys(_this.mountingMaterialItem.laenge).length > 0 ? parseToGermanFloat(_this
                        .mountingMaterialItem.laenge.value.value) : 0;
                    // return 0;
                },
                set: function (newValue) {
                    // const _this = this;
                    this.mountingMaterialItem.laenge.value.value = parseFloatFromGermanFloat(newValue);
                }
            },
            itemAnzahl: {
                get: function () {
                    const _this = this;

                    return Object.keys(_this.mountingMaterialItem.anzahl).length > 0 ? parseToGermanFloat(_this
                        .mountingMaterialItem.anzahl.value.value) : 0;
                    // return 0;
                },
                set: function (newValue) {
                    // const _this = this;
                    // // console.log(this.mountingMaterialItem.materialArt.value.value)
                    // console.log(this.mountingMaterialItem.anzahl.code)
                    this.mountingMaterialItem.anzahl.value.value = parseFloatFromGermanFloat(newValue);

                     // this.changeCharacteristic(this.mountingMaterialItem.anzahl, newValue, this.constCharacteristics.FIELDS.ANZ_FIELD)
                }
            },
            hoeheValue: {
                get: function(){
                    return Object.keys(this.mountingMaterialItem.hoehe).length > 0 ? this.mountingMaterialItem.hoehe.value.value : 0;
                }
            },
            breiteValue: {
                get: function(){
                    return Object.keys(this.mountingMaterialItem.breite).length > 0 ? this.mountingMaterialItem.breite.value.value : 0;
                }
            },
            laengeValue: {
                get: function(){
                    return Object.keys(this.mountingMaterialItem.laenge).length > 0 ? this.mountingMaterialItem.laenge.value.value : 0;
                }
            },
            anzahlValue: {
                get: function(){
                    return Object.keys(this.mountingMaterialItem.anzahl).length > 0 ? this.mountingMaterialItem.anzahl.value.value : 0;
                }
            },
        },
        watch: {
            // Whenever the main material art changes, set dependencies for 
            mainMaterialArt(mainMaterialArt) {
                this.mountingMaterialItem.materialArt = mainMaterialArt;
                const beschichtungsseiteFilter = {

                    anchorCharacteristic: this.mountingMaterialItem.beschichtungsseite,

                    dependencieCharacteristic: [this.mountingMaterialItem.materialArt]
                }
                const farbeFilter = {

                    anchorCharacteristic: this.mountingMaterialItem.farbe,

                    dependencieCharacteristic: [this.mountingMaterialItem.materialArt, this.mountingMaterialItem.beschichtungsseite]
                }
                this.setCharacteristicDependencies(beschichtungsseiteFilter);
                this.setCharacteristicDependencies(farbeFilter);
            },
            grosseSource() {
                // console.log('Groesse source changed...');

                const selectedCharacteristic = MapCharacteristicAndValue(this.grosseSourceListCharacteristic,
                    this.grosseSourceListCharacteristic.values[0]);

                this.mountingMaterialItem.grosse = selectedCharacteristic;
                this.setItemHoeheBreiteValue();
            },
            // a watcher for getChildCharacteristics computed property, defined in the mountingMaterialStore that returnes childCharacteristics
            getChildCharacteristics(getChildCharacteristics) {

                if (this.childCharacteristicsLocal.length == 0) {

                    this.childCharacteristicsLocal = getChildCharacteristics;

                    this.setItemHoeheBreiteValue();
                }
            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration', 'setMainNavigationItems',
                'setMainNavActiveId', 'incrementMainNavActiveId'
            ]),
            ...mapActions('mountingMaterialModule', ['addMountingMaterial', 'clearMountingMaterialList',
                'setChildCharacteristics', 'setCharacteristicDependencies', 'addMountingMaterialForSap', 'updateBlindstockForSap'
                //'setCharacteristicsFromDB'
            ]),
            uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },

            changeCharacteristic: function(option, data, key) {
                option.value.value = parseFloatFromGermanFloat(data);
                if(this.mountingMaterialItem.materialArt.value.value === this.constCharacteristics.WINKEL_OPTION.NAME){
                    if(key === this.constCharacteristics.FIELDS.ANZ_FIELD){
                        option.code = this.constCharacteristics.WINKEL_OPTION.ANZ_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.BREITE_FIELD) {
                        option.code = this.constCharacteristics.WINKEL_OPTION.BREITE_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.HOEHE_FIELD) {
                        option.code = this.constCharacteristics.WINKEL_OPTION.HOEHE_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.LAENGE_FIELD) {
                        option.code = this.constCharacteristics.WINKEL_OPTION.LAENGE_FIELD;
                    }
                }
                else if (this.mountingMaterialItem.materialArt.value.value === this.constCharacteristics.ABDECKLEISTE_OPTION.NAME) {
                    if(key === this.constCharacteristics.FIELDS.ANZ_FIELD){
                        option.code = this.constCharacteristics.ABDECKLEISTE_OPTION.ANZ_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.BREITE_FIELD) {
                        option.code = this.constCharacteristics.ABDECKLEISTE_OPTION.BREITE_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.HOEHE_FIELD) {
                        option.code = this.constCharacteristics.ABDECKLEISTE_OPTION.HOEHE_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.LAENGE_FIELD) {
                        option.code = this.constCharacteristics.ABDECKLEISTE_OPTION.LAENGE_FIELD;
                    }
                }
                else if (this.mountingMaterialItem.materialArt.value.value === this.constCharacteristics.MDF_OPTION.NAME) {
                    if(key === this.constCharacteristics.FIELDS.ANZ_FIELD){
                        option.code = this.constCharacteristics.MDF_OPTION.ANZ_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.BREITE_FIELD) {
                        option.code = this.constCharacteristics.MDF_OPTION.BREITE_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.HOEHE_FIELD) {
                        option.code = this.constCharacteristics.MDF_OPTION.HOEHE_FIELD;
                    }
                    else if(key === this.constCharacteristics.FIELDS.LAENGE_FIELD) {
                        option.code = this.constCharacteristics.MDF_OPTION.LAENGE_FIELD;
                    }
                }
            },

            selectText: function() {
                document.getElementById("itemAnzahl").select();
            },

            setItemHoeheBreiteValue(){
                const hoeheValue = this.getHeightProperty();
                const breiteValue = this.getWidthProperty();
                const isHoeheDisabled = this.isSpecialHohe(this.mainMaterialArt.value, this.mountingMaterialItem.grosse.value);
                const isBreiteDisabled = this.isSpecialDesign(this.mainMaterialArt.value, this.mountingMaterialItem.grosse.value);
                
                // debugger;
                this.itemHoehe = isHoeheDisabled ? hoeheValue : 0;
                this.itemBreite = isBreiteDisabled ? breiteValue : 0;
            },

            displayDescription(fn) {
                try {
                    return fn();
                } catch (e) {
                    return 'Initializing...';
                }
            },

            getWidthProperty() {

                if (this.childCharacteristicsLocal.length === 0 || typeof this.mountingMaterialItem.grosse
                    .value === 'undefined') {
                    return 0;
                }

                const selectedValue = this.mountingMaterialItem.grosse.value.value;
                const property = `${selectedValue}_width`;

                const characteristic = this.childCharacteristicsLocal.filter((x) => x.code === property)[0];

                if (typeof characteristic === 'undefined') {
                    return 0;
                }

                const mappedChar = MapCharacteristicAndValue(characteristic, characteristic.values[0]);
                return mappedChar.value.value;
            },
            getHeightProperty() {
                if (this.childCharacteristicsLocal.length === 0 || typeof this.mountingMaterialItem.grosse
                    .value === 'undefined') {
                    return 0;
                }

                const selectedValue = this.mountingMaterialItem.grosse.value.value;
                const property = `${selectedValue}_height`;

                const characteristic = this.childCharacteristicsLocal.filter((x) => x.code === property)[0];

                if (typeof characteristic === 'undefined') {
                    return 0;
                }

                const mappedChar = MapCharacteristicAndValue(characteristic, characteristic.values[0]);
                return mappedChar.value.value;
            },

            toggleModal(state) {
                const _this = this;
                _this.showModal = state;
            },
            settingsNavigation(index) {
                const _this = this;
                _this.active = index;
                _this.showSettingsContent = index;
            },
            setMainMaterialArtValue(characteristic, valueDefinition) {
                const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
                this.mainMaterialArt = selectedCharacteristic;
            },
            addMaterialItemCharacterisitc(materialItem, characteristic, valueDefinition) {

                const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);

                this.mountingMaterialItem[materialItem] = selectedCharacteristic;

                this.setItemHoeheBreiteValue();

                // const configuration = context.rootState.doorConfiguration;
                // configuration.Add(DoorConfiguration.Measure, selectedCharacteristic);                
                // this.addMountingMaterial(selectedCharacteristic);
            },
            addMaterialItem() {
                // debugger;
                const valid = this.$refs.mountingMaterialForm.validate();
                if(!valid)
                    return;
                document.defaultCharset = "utf-8"
                this.changeCharacteristic(this.mountingMaterialItem.anzahl, this.itemAnzahl, this.constCharacteristics.FIELDS.ANZ_FIELD)
                this.changeCharacteristic(this.mountingMaterialItem.breite, this.itemBreite, this.constCharacteristics.FIELDS.BREITE_FIELD)
                this.changeCharacteristic(this.mountingMaterialItem.hoehe, this.itemHoehe, this.constCharacteristics.FIELDS.HOEHE_FIELD)
                this.changeCharacteristic(this.mountingMaterialItem.laenge, this.itemLaenge, this.constCharacteristics.FIELDS.LAENGE_FIELD)
                this.mountingMaterialItem.id = this.uuidv4();
                const mountingMaterialItem1 = JSON.parse(JSON.stringify(this.mountingMaterialItem));

                this.addMountingMaterial(mountingMaterialItem1);

                let isAnyMountingMaterial = this.getMountingMaterialItemsForSap.length;
                let isAnyItemFree = false;
                let itemFreeIndex = 0;
                if(isAnyMountingMaterial > 0) {
                    for(let v = 0; v < isAnyMountingMaterial;v++) {
                        if(this.getMountingMaterialItemsForSap[v].find(x => x.code === mountingMaterialItem1.grosse.code).value === "")
                        {
                            isAnyItemFree = true;
                            itemFreeIndex = v;
                            break;
                        }
                        else {
                            isAnyItemFree = false;
                            itemFreeIndex = 0;
                        }
                    }

                    if(isAnyItemFree === true) {
                        let obj = [];
                        let payloadValue = {
                            index: itemFreeIndex,
                            data: obj
                        };
                        if(mountingMaterialItem1.grosse.code === 'KTU_MM_ABDECKLEISTE') {
                            for (let i = 0; i < this.mountingMaterialCharacteristicsForSapAbdeckleiste.length; i++) {
                                if(this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === mountingMaterialItem1.grosse.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.grosse.code,
                                        "value": mountingMaterialItem1.grosse.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === mountingMaterialItem1.beschichtungsseite.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.beschichtungsseite.code,
                                        "value": mountingMaterialItem1.beschichtungsseite.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === mountingMaterialItem1.farbe.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.farbe.code,
                                        "value": mountingMaterialItem1.farbe.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === mountingMaterialItem1.hoehe.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.hoehe.code,
                                        "value": mountingMaterialItem1.hoehe.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === mountingMaterialItem1.breite.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.breite.code,
                                        "value": mountingMaterialItem1.breite.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === mountingMaterialItem1.laenge.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.laenge.code,
                                        "value": mountingMaterialItem1.laenge.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === mountingMaterialItem1.anzahl.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.anzahl.code,
                                        "value": mountingMaterialItem1.anzahl.value.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === "KTU_MM_ABDECKLEISTE_O") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapAbdeckleiste[i],
                                        "value": selectMountingMaterialColor.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === "KTU_MM_ABDECKLEISTE_O_SO") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapAbdeckleiste[i],
                                        "value": selectMountingMaterialColor.original
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === "KTU_MM_ABDECKLEISTE_O_ART") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    let getValue = this.getValueOfArt("KTU_MM_ABDECKLEISTE_O_ART",mountingMaterialItem1.beschichtungsseite.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapAbdeckleiste[i],
                                        "value": getValue
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === "KTU_MM_WINKEL_O") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapAbdeckleiste[i],
                                        "value": selectMountingMaterialColor.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === "KTU_MM_WINKEL_O_SO") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapAbdeckleiste[i],
                                        "value": selectMountingMaterialColor.original
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapAbdeckleiste[i] === "KTU_MM_WINKEL_O_ART") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    let getValue = this.getValueOfArt("KTU_MM_WINKEL_O_ART",mountingMaterialItem1.beschichtungsseite.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapAbdeckleiste[i],
                                        "value": getValue
                                    });
                                }
                                else {
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapAbdeckleiste[i],
                                        "value": ''
                                    });
                                }
                            }
                        }
                        else if(mountingMaterialItem1.grosse.code === 'KTU_MM_MDF') {
                            for (let i = 0; i < this.mountingMaterialCharacteristicsForSapMdf.length; i++) {
                                if(this.mountingMaterialCharacteristicsForSapMdf[i] === mountingMaterialItem1.grosse.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.grosse.code,
                                        "value": mountingMaterialItem1.grosse.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapMdf[i] === mountingMaterialItem1.beschichtungsseite.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.beschichtungsseite.code,
                                        "value": mountingMaterialItem1.beschichtungsseite.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapMdf[i] === mountingMaterialItem1.farbe.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.farbe.code,
                                        "value": mountingMaterialItem1.farbe.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapMdf[i] === mountingMaterialItem1.hoehe.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.hoehe.code,
                                        "value": mountingMaterialItem1.hoehe.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapMdf[i] === mountingMaterialItem1.breite.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.breite.code,
                                        "value": mountingMaterialItem1.breite.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapMdf[i] === mountingMaterialItem1.laenge.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.laenge.code,
                                        "value": mountingMaterialItem1.laenge.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapMdf[i] === mountingMaterialItem1.anzahl.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.anzahl.code,
                                        "value": mountingMaterialItem1.anzahl.value.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapMdf[i] === "KTU_MM_ABDECKLEISTE_O") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapMdf[i],
                                        "value": selectMountingMaterialColor.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapMdf[i] === "KTU_MM_ABDECKLEISTE_O_SO") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapMdf[i],
                                        "value": selectMountingMaterialColor.original
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapMdf[i] === "KTU_MM_ABDECKLEISTE_O_ART") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    let getValue = this.getValueOfArt("KTU_MM_ABDECKLEISTE_O_ART",mountingMaterialItem1.beschichtungsseite.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapMdf[i],
                                        "value": getValue
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapMdf[i] === "KTU_MM_WINKEL_O") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapMdf[i],
                                        "value": selectMountingMaterialColor.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapMdf[i] === "KTU_MM_WINKEL_O_SO") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapMdf[i],
                                        "value": selectMountingMaterialColor.original
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapMdf[i] === "KTU_MM_WINKEL_O_ART") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    let getValue = this.getValueOfArt("KTU_MM_WINKEL_O_ART",mountingMaterialItem1.beschichtungsseite.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapMdf[i],
                                        "value": getValue
                                    });
                                }
                                else {
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapMdf[i],
                                        "value": ''
                                    });
                                }
                            }
                        }
                        else if(mountingMaterialItem1.grosse.code === 'KTU_MM_WINKEL') {
                            for (let i = 0; i < this.mountingMaterialCharacteristicsForSapWinkel.length; i++) {
                                if(this.mountingMaterialCharacteristicsForSapWinkel[i] === mountingMaterialItem1.grosse.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.grosse.code,
                                        "value": mountingMaterialItem1.grosse.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapWinkel[i] === mountingMaterialItem1.beschichtungsseite.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.beschichtungsseite.code,
                                        "value": mountingMaterialItem1.beschichtungsseite.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapWinkel[i] === mountingMaterialItem1.farbe.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.farbe.code,
                                        "value": mountingMaterialItem1.farbe.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapWinkel[i] === mountingMaterialItem1.hoehe.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.hoehe.code,
                                        "value": mountingMaterialItem1.hoehe.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapWinkel[i] === mountingMaterialItem1.breite.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.breite.code,
                                        "value": mountingMaterialItem1.breite.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapWinkel[i] === mountingMaterialItem1.laenge.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.laenge.code,
                                        "value": mountingMaterialItem1.laenge.value.value
                                    });
                                }
                                else if(this.mountingMaterialCharacteristicsForSapWinkel[i] === mountingMaterialItem1.anzahl.code) {
                                    obj.push({
                                        "code": mountingMaterialItem1.anzahl.code,
                                        "value": mountingMaterialItem1.anzahl.value.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapWinkel[i] === "KTU_MM_ABDECKLEISTE_O") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapWinkel[i],
                                        "value": selectMountingMaterialColor.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapWinkel[i] === "KTU_MM_ABDECKLEISTE_O_SO") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapWinkel[i],
                                        "value": selectMountingMaterialColor.original
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapWinkel[i] === "KTU_MM_ABDECKLEISTE_O_ART") && (mountingMaterialItem1.materialArt.value.value === "ABDECKLEISTE")) {
                                    let getValue = this.getValueOfArt("KTU_MM_ABDECKLEISTE_O_ART",mountingMaterialItem1.beschichtungsseite.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapWinkel[i],
                                        "value": getValue
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapWinkel[i] === "KTU_MM_WINKEL_O") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapWinkel[i],
                                        "value": selectMountingMaterialColor.value
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapWinkel[i] === "KTU_MM_WINKEL_O_SO") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    const mountingMaterialColors = filterMountingMaterialColor();
                                    const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === mountingMaterialItem1.farbe.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapWinkel[i],
                                        "value": selectMountingMaterialColor.original
                                    });
                                }
                                else if((this.mountingMaterialCharacteristicsForSapWinkel[i] === "KTU_MM_WINKEL_O_ART") && (mountingMaterialItem1.materialArt.value.value === "WINKEL")) {
                                    let getValue = this.getValueOfArt("KTU_MM_WINKEL_O_ART",mountingMaterialItem1.beschichtungsseite.value.value);
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapWinkel[i],
                                        "value": getValue
                                    });
                                }
                                else {
                                    obj.push({
                                        "code": this.mountingMaterialCharacteristicsForSapWinkel[i],
                                        "value": ''
                                    });
                                }
                            }
                        }
                        this.updateBlindstockForSap(payloadValue);
                    }
                    else {
                        this.addMaterialItemForSap(mountingMaterialItem1);
                    }
                }else {
                    this.addMaterialItemForSap(mountingMaterialItem1);
                }


                // _this.initialMaterialItemState();
            },
            addMaterialItemForSap(data) {
                let obj = [];

                for (let i = 0; i < this.mountingMaterialCharacteristicsForSap.length; i++) {
                    if(this.mountingMaterialCharacteristicsForSap[i] === data.materialArt.code) {
                        obj.push({
                            "code": data.materialArt.code,
                            "value": data.materialArt.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.grosse.code) {
                        obj.push({
                            "code": data.grosse.code,
                            "value": data.grosse.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.beschichtungsseite.code) {
                        obj.push({
                            "code": data.beschichtungsseite.code,
                            "value": data.beschichtungsseite.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.farbe.code) {
                        obj.push({
                            "code": data.farbe.code,
                            "value": data.farbe.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.hoehe.code) {
                        obj.push({
                            "code": data.hoehe.code,
                            "value": data.hoehe.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.breite.code) {
                        obj.push({
                            "code": data.breite.code,
                            "value": data.breite.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.laenge.code) {
                        obj.push({
                            "code": data.laenge.code,
                            "value": data.laenge.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.anzahl.code) {
                        obj.push({
                            "code": data.anzahl.code,
                            "value": data.anzahl.value.value
                        });
                    }
                    else if((this.mountingMaterialCharacteristicsForSap[i] === "KTU_MM_ABDECKLEISTE_O") && (data.materialArt.value.value === "ABDECKLEISTE")) {
                        const mountingMaterialColors = filterMountingMaterialColor();
                        const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === data.farbe.value.value);
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": selectMountingMaterialColor.value
                        });
                    }
                    else if((this.mountingMaterialCharacteristicsForSap[i] === "KTU_MM_ABDECKLEISTE_O_SO") && (data.materialArt.value.value === "ABDECKLEISTE")) {
                        const mountingMaterialColors = filterMountingMaterialColor();
                        const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === data.farbe.value.value);
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": selectMountingMaterialColor.original
                        });
                    }
                    else if((this.mountingMaterialCharacteristicsForSap[i] === "KTU_MM_ABDECKLEISTE_O_ART") && (data.materialArt.value.value === "ABDECKLEISTE")) {
                        let getValue = this.getValueOfArt("KTU_MM_ABDECKLEISTE_O_ART",data.beschichtungsseite.value.value);
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": getValue
                        });
                    }
                    else if((this.mountingMaterialCharacteristicsForSap[i] === "KTU_MM_WINKEL_O") && (data.materialArt.value.value === "WINKEL")) {
                        const mountingMaterialColors = filterMountingMaterialColor();
                        const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === data.farbe.value.value);
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": selectMountingMaterialColor.value
                        });
                    }
                    else if((this.mountingMaterialCharacteristicsForSap[i] === "KTU_MM_WINKEL_O_SO") && (data.materialArt.value.value === "WINKEL")) {
                        const mountingMaterialColors = filterMountingMaterialColor();
                        const selectMountingMaterialColor = mountingMaterialColors.find(x => x.name === data.farbe.value.value);
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": selectMountingMaterialColor.original
                        });
                    }
                    else if((this.mountingMaterialCharacteristicsForSap[i] === "KTU_MM_WINKEL_O_ART") && (data.materialArt.value.value === "WINKEL")) {
                        let getValue = this.getValueOfArt("KTU_MM_WINKEL_O_ART",data.beschichtungsseite.value.value);
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": getValue
                        });
                    }
                    else {
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": ''
                        });
                    }

                }
                const itemForSap = JSON.parse(JSON.stringify(obj));
                this.addMountingMaterialForSap(itemForSap);
                // const itemForSap = JSON.parse(JSON.stringify(data));
                // this.addMountingMaterialForSap(itemForSap);

            },

            getValueOfArt(characteristic,data) {
                let values = this.getCharacteristicAndValues(characteristic).values;
                for(let i = 0; i< values.length; i++) {
                    let splitValue = values[i].value.split(' ');
                    if(data === splitValue[1]) {
                        return values[i].value;
                    }
                    else if(data === splitValue[0]) {
                        return values[i].value;
                    }
                    else if(data === splitValue[0].replace("-", "")) {
                        return values[i].value;
                    }
                }
            },
            // getSettingsItemsFromStore() {    

            //     var setting = this.$store.state.mainMenu.filter((task: any) => task.id === 7);
            //     var settingObject = setting[0];

            //     this.settignsItems = settingObject.characteristicsItems;
            //     // console.log(this.settignsItems);
            // },
            async getCharacteristics() {
                NProgress.start();
                this.nextSaveBtnDisabled = true

                mountingMaterialService.getMountingMaterialCharacteristics()
                    .then(async (response) => {
                        await this.$store.dispatch('mountingMaterialModule/setStepCharacteristics', response
                            .data);
                        // this.$store.dispatch('mountingMaterialModule/setSingleCharacteristicsFilteredOrDefaults');
                        // this.filterMeasureDependencies();
                        // this.dataLoaded = true;
                    }).then(async () => {
                        await this.initialMaterialItemState();
                    })
                    .finally(() => {
                        NProgress.done();
                        this.nextSaveBtnDisabled = false
                    });
            },
            filterDependencies() {
                const beschichtungsseiteFilter = {

                    anchorCharacteristic: this.mountingMaterialItem.beschichtungsseite,

                    dependencieCharacteristic: [this.mountingMaterialItem.materialArt]
                }
                const farbeFilter = {

                    anchorCharacteristic: this.mountingMaterialItem.farbe,

                    dependencieCharacteristic: [this.mountingMaterialItem.materialArt, this.mountingMaterialItem.beschichtungsseite]
                }
                this.setCharacteristicDependencies(beschichtungsseiteFilter);
                this.setCharacteristicDependencies(farbeFilter);
            },
            async initialMaterialItemState() {
                const _this = this;
                // _this.mountingMaterialItem.grosse = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_GROESSE'), _this.getCharacteristicAndValues('CUST_MM_GROESSE').values[0]); 
                // _this.mountingMaterialItem.beschichtungsseite = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE_WINKEL_MDF'), _this.getCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE_WINKEL_MDF').values[0]); 
                // _this.mountingMaterialItem.farbe = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_FARBE'), _this.getCharacteristicAndValues('CUST_MM_FARBE').values[0]); 
                // _this.mountingMaterialItem.hoehe = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_HOHE_STAERKE'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_HOHE_STAERKE').values[0]);;
                // _this.mountingMaterialItem.breite = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_BREITE'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_BREITE').values[0]);;
                // _this.mountingMaterialItem.laenge = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_LAENGE'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_LAENGE').values[0]);;
                // _this.mountingMaterialItem.anzahl = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_ANZ'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_ANZ').values[0]);;

                const mainMatArt = _this.getCharacteristicAndValues('CUST_MM_ART_MATERIAL');

                this.mainMaterialArt = MapCharacteristicAndValue(mainMatArt, mainMatArt.values[0]);

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const mainElementCode = uiCharacteristic.characteristics.filter(x => x.item === 'material')[0]
                    .code;


                const mainElement = _this.getCharacteristicAndValues(mainElementCode);
                const beschichtungsseite = _this.getCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE');
                const farbe = _this.getCharacteristicAndValues('CUST_MM_FARBE');
                const hoehe = _this.getCharacteristicAndValues(this.elementHeightCode);
                const breite = _this.getCharacteristicAndValues(this.elementWidthCode);
                const laenge = _this.getCharacteristicAndValues(this.elementLengthCode);
                const anzahl = _this.getCharacteristicAndValues(this.numberOfItemsCode);


                _this.mountingMaterialItem.materialArt = this.mainMaterialArt;
                _this.mountingMaterialItem.grosse = Object.keys(_this.mountingMaterialItem.grosse).length <=
                    0 && MapCharacteristicAndValue(mainElement, mainElement.values[0]);
                _this.mountingMaterialItem.beschichtungsseite = Object.keys(_this.mountingMaterialItem
                    .beschichtungsseite).length <= 0 && MapCharacteristicAndValue(beschichtungsseite,
                    beschichtungsseite.values[0]);
                _this.mountingMaterialItem.farbe = Object.keys(_this.mountingMaterialItem.farbe).length <= 0 &&
                    MapCharacteristicAndValue(farbe, farbe.values[0]);
                _this.mountingMaterialItem.hoehe = Object.keys(_this.mountingMaterialItem.hoehe).length <= 0 &&
                    MapCharacteristicAndValue(hoehe, hoehe.values[0]);
                _this.mountingMaterialItem.breite = Object.keys(_this.mountingMaterialItem.breite).length <=
                    0 && MapCharacteristicAndValue(breite, breite.values[0]);
                _this.mountingMaterialItem.laenge = Object.keys(_this.mountingMaterialItem.laenge).length <=
                    0 && MapCharacteristicAndValue(laenge, laenge.values[0]);
                _this.mountingMaterialItem.anzahl = Object.keys(_this.mountingMaterialItem.anzahl).length <=
                    0 && MapCharacteristicAndValue(anzahl, anzahl.values[0]);

              this.$refs.mountingMaterialForm.resetValidation()
            },
            resetModelSelection() {
                const _this = this;
                _this.doorConfiguration = _this.getCurrentDoorConfiguration;
                _this.doorConfiguration.ClearConfiguration(DoorConfiguration.MountingMaterial);
                _this.$store.dispatch('updateDoorConfiguration', _this.doorConfiguration);

                // this.updateNavigation();
                let mainNav = new MainNavigationFilter(_this.getMainNav);
                let mainNavItems = mainNav.ResetMainNavigationItemStatus(_this.windowMainNavId, false);
                _this.setMainNavigationItems(mainNavItems);
            },
            nextStep() {
                const _this = this;
                let mainNav = new MainNavigationFilter(_this.getMainNav);
                let mainNavItems = mainNav.UpdateMainNavigation(_this.getNavigationItems, _this
                    .windowMainNavId + 1);
                // this.$store.dispatch('setMainNavigationItems', mainNavItems);
                _this.setMainNavigationItems(mainNavItems);

                const nextMainNavItem = mainNavItems.filter(x => x.itemId == _this.windowMainNavId + 1)[0];
                if (nextMainNavItem.disabled == false) {
                    /* _this.setMainNavActiveId(_this.windowMainNavId + 1); */
					const activeMainNavIndex = this.getMainNav.findIndex(f => f.itemId === this.windowMainNavId)
                    _this.incrementMainNavActiveId(activeMainNavIndex);
					this.$EventBus.$emit('triggerMaxHeight')
                    _this.$router.push('/product-configurator' + nextMainNavItem.route);
                } else {
                    // console.log('Mounting Material step not completed!');
                }
            },
            isSpecialDesign(material, size){
                if(typeof material !== 'undefined' && typeof size !== 'undefined') {
                    if(material.value === 'WINKEL')
                    {
                        if(size.value === 'LLT800009') {
                            return false;
                        }
                    }
                    else if (material.value === 'ABDECKLEISTE') {
                        if(size.value === 'LLT800043') {
                            return false;
                        }
                    }
                    else if(material.value === 'AUFDOPPELUNG'){
                        const llts = ['LLT800019', 'LLT800020', 'LLT800021', 'LLT800022', 'LLT800028', 'LLT800029', 'LLT800030', 'LLT800031']
                        if(llts.includes(size.value)){
                            return false;
                        }
                    }
                }

                return true;
            },
            isSpecialHohe(material, size){
                if(typeof material !== 'undefined' && typeof size !== 'undefined'){
                    if(material.value === 'AUFDOPPELUNG'){
                        return false;
                    }
                }
                return true;
            },
            recalcBodyHeight(){
                //calculation of top-bar height 
                if(this.$refs.topBar.clientHeight != this.bodyCalcHeight)
                    this.bodyCalcHeight = this.$refs.topBar.clientHeight;
            }
        },
        created() {
            window.addEventListener("resize", this.recalcBodyHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.recalcBodyHeight);
        },
        async mounted() {
            await this.getCharacteristics();
            this.setChildCharacteristics();

            //calculation of top-bar height 
            this.bodyCalcHeight = this.$refs.topBar.clientHeight;

            // this.$nextTick(() => {
            //     this.$refs.mountingMaterialForm.resetValidation()
            // })
            // NProgress.start();
            // this.setCharacteristicsFromDB().then(() => {
            //     NProgress.done();
            //     // _this.initialMaterialItemState();
            //     // console.log('ready for next action...')
            // });
            // if (this.childCharacteristicsLocal.length == 0) {
            //     this.childCharacteristicsLocal = _this.getChildCharacteristics;
            // } 
        }
    });
</script>

<style lang="scss" scoped>
    .main-row-fill-height{
        height: 100%;
        margin-left: 0;
        margin-right: 0;
        >.col{
            max-height: 100%;
        }
    }
</style>